export default __webpack_public_path__ + "static/react-9cbb1f2856ec5748f9d1e0a3cb74581f.webp";